angular.module('invoice')
    .controller('InvoiceShowFullController', function ($scope, $window, $state, $stateParams, $rootScope, Invoice, InvoiceService, InvoiceConst, Principal) {
        this.InvoiceService = InvoiceService
        this.Principal = Principal

        this.$onInit = () => {
            this.loadInvoice($stateParams.id)
            this.isAccountantOrManager = InvoiceService.isUserAccountantOrManager()
            this.canReadInvoiceBgt = Principal.hasAnyAuthority(['ROLE_INVOICE_DOCUMENTS_BGT_READ', 'ROLE_INVOICE_DOCUMENTS_BGT_WRITE_WITH_READ_ACCESS', 'ROLE_ADMIN'])
            this.canReadSubcontractorStatements = Principal.hasAnyAuthority([
                'ROLE_INVOICE_DOCUMENTS_SUBCONTRACTOR_STATEMENTS_READ',
                'ROLE_INVOICE_DOCUMENTS_SUBCONTRACTOR_STATEMENTS_WRITE_WITH_READ_ACCESS',
                'ROLE_ADMIN'
            ])
            this.canReadKSEF = Principal.hasAnyAuthority(['ROLE_INVOICE_DOCUMENTS_KSEF_REGISTRY', 'ROLE_INVOICE_DOCUMENTS_KSEF_SETTINGS', 'ROLE_ADMIN'])
            this.canResetKsefXmlExport = Principal.hasAnyAuthority(['ROLE_INVOICE_DOCUMENTS_EXPORT'])
            this.canReadBusinessThread = Principal.hasAnyAuthority(['ROLE_BUSINESS_THREAD'])
        }
        this.loadInvoice = (id) => {
            Invoice.get({id: id}).$promise.then(item => {
                this.item = item
                Principal.currentUser().then(user => {
                    this.isWorker = this.item.worker.id === user.id
                })
            })
            Invoice.touches({id: id}).$promise.then(items => this.touches = items)
        }
        this.onSettlementChanged = () => {
            this.loadInvoice($stateParams.id)
        }
        this.cancel = () => $window.history.back()
        this.canCancel = () => $window.history.length > 1
        this.resetKsefXmlExport = () => {
            if (!this.item || !this.item.id) {
                return
            }
            return InvoiceService.resetKsefXmlExport([this.item.id])
        }

        $scope.$on(InvoiceConst.eventUpdate, () => {
            $rootScope.$broadcast('document.comments.reload', this.item.id)
            this.$onInit()
        })
        $scope.$on("file.saved", () => this.$onInit())
    })
